// extracted by mini-css-extract-plugin
export default {"root":"ShareButton_root__NSNh6","icon":"ShareButton_icon__LckeE","button":"ShareButton_button__LP+6P p"};